import { useTranslation } from '../../i18n/TranslationContext';

export default function Footer() {
  const { t } = useTranslation();

  return (
    <footer className="bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-8 md:py-10">
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-2">
            <img src="/logo.png" alt="Dragonfruit" className="h-5 w-auto" />
            <span className="text-foreground-600 text-xs">{t('footer.copyright')}</span>
          </div>
          <div className="flex items-center gap-6">
            <a href="/privacy" className="text-foreground-500 text-xs hover:text-foreground-700 transition-colors cursor-pointer">
              {t('footer.privacy')}
            </a>
            <a href="/terms" className="text-foreground-500 text-xs hover:text-foreground-700 transition-colors cursor-pointer">
              {t('footer.terms')}
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
